// Wybór języka (SPIS I18-2, PLAN-ZROWNANIA etap 8): zapisany przy koncie - ten sam na każdym telefonie, w powiadomieniach
// i w PDF przepisów. Nazwy języków w ich własnym języku (lista z workera). Jeden wybór w dwóch miejscach: okno
// „Wyświetlanie” z menu konta (uklad/Wyswietlanie.tsx) i sekcja „Język” w Ustawieniach.
import { useState } from "react";
import { JEZYKI, type JezykAPP } from "../../gen/kontrakt";
import { jezykAPP, t, ustawJezyk } from "../../i18n/t";
import { PoleWyboru } from "../../uklad/Pola";

export function WyborJezyka({ etykieta }: { etykieta: string }) {
  const [zajety, ustawZajety] = useState(false);
  const [blad, ustawBlad] = useState(false);
  const zmien = (j: JezykAPP) => {
    ustawZajety(true);
    ustawBlad(false);
    ustawJezyk(j, true).catch(() => { ustawBlad(true); ustawZajety(false); });
  };
  return (
    <PoleWyboru etykieta={etykieta} wartosc={jezykAPP()} disabled={zajety} onZmien={zmien}
      pomoc={zajety ? t("Zmieniam język…") : undefined}
      blad={blad ? t("Nie udało się zmienić języka. Spróbuj ponownie.") : undefined}
      opcje={JEZYKI.map(([kod, nazwa]) => ({ wartosc: kod, etykieta: nazwa }))} />
  );
}
